function getCurrentOrigin(): string | undefined {
  return typeof location === 'undefined' ? undefined : location.origin;
}

export function getRenderableAvatarImageUrl(
  url: string | null | undefined,
  baseOrigin = getCurrentOrigin()
): string | undefined {
  const value = url?.trim();
  if (!value) {
    return undefined;
  }

  if (value.startsWith('blob:')) {
    return value;
  }

  if (value.startsWith('data:image/')) {
    return value;
  }

  if (!baseOrigin) {
    return undefined;
  }

  try {
    const parsed = new URL(value, baseOrigin);
    if (
      (parsed.protocol === 'http:' || parsed.protocol === 'https:') &&
      parsed.origin === baseOrigin
    ) {
      return value;
    }
  } catch {
    return undefined;
  }

  return undefined;
}
